import type { AllRouteEndpoints } from "../routeTypes";
import { cacheKey as teamsData } from "../teamsData";
export const appsAppGroupIdTerritoryEditCacheKeys: AllRouteEndpoints[] = [teamsData];
